import Kategori from "../../../../../components/categories/superadmin/privilege/kategori/Home"

export default function Home() {  
  return (
    <Kategori />
  );
}
